export interface UnlinkOptions {
  /** Writes the unlinked resolve map to `resolve-map-unlinked.json`. */
  logResolveMap?: boolean;
}
